import apiClient from "../apiClient";
import { API_ENDPOINTS } from "../config";

const communicationLogService = {
  // Get all communication logs
  getCommunicationLogs: async (params = {}) => {
    try {

      const queryString = new URLSearchParams(params).toString();
      const response = await apiClient.get(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.LIST}?${queryString}`
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Get communication log by ID
  getCommunicationLogById: async (id) => {
    try {

      const response = await apiClient.get(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.GET(id)}`
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Get communication log by ID (alias for consistency)
  getCommunicationLog: async (id) => {
    return communicationLogService.getCommunicationLogById(id);
  },

  // Create new communication log
  createCommunicationLog: async (data) => {
    try {





      const response = await apiClient.post(
        API_ENDPOINTS.COMMUNICATION_LOGS.CREATE,
        data
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Update communication log
  updateCommunicationLog: async (id, data) => {
    try {

      const response = await apiClient.put(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.UPDATE(id)}`,
        data
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Delete communication log
  deleteCommunicationLog: async (id) => {
    try {

      const response = await apiClient.delete(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.DELETE(id)}`
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Reply to communication
  replyToCommunication: async (id, data) => {
    try {

      const response = await apiClient.post(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.REPLY(id)}`,
        data
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Forward communication
  forwardCommunication: async (id, data) => {
    try {

      const response = await apiClient.post(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.FORWARD(id)}`,
        data
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Export communication logs
  exportCommunicationLogs: async (params = {}) => {
    try {

      const queryString = new URLSearchParams(params).toString();
      const response = await apiClient.get(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.EXPORT}?${queryString}`
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Get communication statistics
  getCommunicationStats: async () => {
    try {

      const response = await apiClient.get(
        API_ENDPOINTS.COMMUNICATION_LOGS.STATS
      );

      return response;
    } catch (error) {

      throw error;
    }
  },

  // Reply to communication log
  replyToCommunicationLog: async (id, data) => {
    try {

      const response = await apiClient.post(
        `${API_ENDPOINTS.COMMUNICATION_LOGS.REPLY(id)}`,
        data
      );

      return response;
    } catch (error) {

      throw error;
    }
  },
};

export default communicationLogService;
